import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules } from '@/support/ValidationRules';
import { SupplierSize } from '@/models/SupplierSize';
import { cloneDeep } from 'lodash';

@Component<SupplierSizeCreateOrUpdateDialog>({})
export default class SupplierSizeCreateOrUpdateDialog extends Vue {
  @Prop({ default: undefined })
  protected originalSupplierSize!: SupplierSize;

  protected isFormValid: boolean = false;

  protected isLoading: boolean = false;

  protected supplierSize: SupplierSize = new SupplierSize({ default_order_quantity: 1 });

  protected rules: Rules = EnglishRules;

  protected mounted(): void {
    this.initialize();
  }

  protected initialize(): void {
    if (!this.originalSupplierSize) { return; }

    this.supplierSize = cloneDeep(this.originalSupplierSize);

    this.supplierSize.size_id =
      this.originalSupplierSize.size
      && this.originalSupplierSize.size.id
        ? this.originalSupplierSize.size.id
        : '';
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async onSaveButtonClick(): Promise<void> {
    if (! this.canSaveSupplierSize) { return; }

    this.isLoading = true;

    const supplierSize = this.originalSupplierSize
      ? await this.update()
      : await this.create();

    if (supplierSize) {
      this.originalSupplierSize
        ? this.$emit('sizeUpdated', supplierSize)
        : this.$emit('sizeCreated', supplierSize);

      this.close();
    }

    this.isLoading = false;
  }

  protected async update(): Promise<null | SupplierSize> {
    if (! this.supplierSize) { return null; }

    const supplierSize = await this.supplierSize
      .update()
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        return null;
      });

    return supplierSize;
  }

  protected async create(): Promise<null | SupplierSize> {
    const supplierSize = await this.supplierSize
      .create()
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        return null;
      });

    return supplierSize;
  }

  protected get canSaveSupplierSize() {
    return this.isFormValid && ! this.isLoading;
  }

  protected get saveButtonText(): string {
    return this.originalSupplierSize
      ? 'Edit'
      : 'Add';
  }
}
